'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormSection from './FormSection';
import FormField from './FormField';
import RadioOption from './RadioOption';
import TextInput from './TextInput';
import SelectInput from './SelectInput';
import type { RSVPFormData } from './RSVPPageClient';

const transportOptions = [
  { value: 'flight', label: '✈️ Flight' },
  { value: 'train', label: '🚆 Train' },
  { value: 'bus', label: '🚌 Bus' },
  { value: 'car', label: '🚗 Car / Personal vehicle' },
  { value: 'other', label: 'Other' },
];

const pickupOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'unsure', label: 'Not sure yet' },
];

export default function Section3BhopalJourney() {
  const { register } = useFormContext<RSVPFormData>();

  return (
    <FormSection
      number={3}
      title="Your Journey to Bhopal"
      description="This helps us plan your arrival and pickup if required."
      infoBox={
        <>
          <strong style={{ color: 'var(--foreground)' }}>
            Engagement Venue
          </strong>
          <br />
          Aakriti Eco City, Salaiya, Bhopal, Madhya Pradesh 462039
          <br />
          31 December 2026 · 12 PM – 5 PM
        </>
      }
    >
      <FormField label="How will you reach Bhopal?">
        <div className="grid gap-2 mt-1">
          {transportOptions.map((opt) => (
            <RadioOption
              key={`bhopal-transport-${opt.value}`}
              name="bhopalTransport"
              value={opt.value}
              label={opt.label}
              registerProps={register('bhopalTransport')}
            />
          ))}
        </div>
      </FormField>

      <FormField
        label="Expected arrival date in Bhopal"
        htmlFor="bhopalArrivalDate"
      >
        <TextInput
          id="bhopalArrivalDate"
          type="date"
          min="2026-12-29"
          max="2027-01-04"
          registerProps={register('bhopalArrivalDate')}
        />
      </FormField>

      <FormField
        label="Approximate arrival time"
        htmlFor="bhopalArrivalTime"
      >
        <TextInput
          id="bhopalArrivalTime"
          type="time"
          registerProps={register('bhopalArrivalTime')}
        />
      </FormField>

      <FormField
        label="Where will you arrive in Bhopal?"
        htmlFor="bhopalArrivalPoint"
      >
        <SelectInput
          id="bhopalArrivalPoint"
          registerProps={register('bhopalArrivalPoint')}
        >
          <option value="">Select arrival point</option>
          <option value="Bhopal Airport">Bhopal Airport</option>
          <option value="Bhopal Railway Station">
            Bhopal Railway Station
          </option>
          <option value="Bus Stand">Bus Stand</option>
          <option value="By road / Personal vehicle">
            By road / Personal vehicle
          </option>
          <option value="Other">Other</option>
        </SelectInput>
      </FormField>

      <FormField label="Would you need pickup assistance in Bhopal?">
        <div className="grid gap-2 mt-1">
          {pickupOptions.map((opt) => (
            <RadioOption
              key={`bhopal-pickup-${opt.value}`}
              name="bhopalPickup"
              value={opt.value}
              label={opt.label}
              registerProps={register('bhopalPickup')}
            />
          ))}
        </div>
      </FormField>
    </FormSection>
  );
}